<small>
    @if(licenceUsageWithDiff.diff > 0){
        (<i class="fal fa-arrow-up-right"></i>️ +{{licenceUsageWithDiff.diff}})
    } @else if (licenceUsageWithDiff.diff === 0){
        (-)
    } @else {
        (<i class="fal fa-arrow-down-right"></i> {{licenceUsageWithDiff.diff}})
    }
</small>